import { call } from 'redux-saga/effects';
import { SignalingSocket } from 'services/signaling';
import { logger } from 'utils/logger';
import { bulkMuteRemoteAudio } from 'features/streaming/actions';

export function* bulkMuteRemoteAudioSaga({ payload }: ReturnType<typeof bulkMuteRemoteAudio>) {
  logger
    .remote({ action: true })
    .log('Bulk mute remote audio requested', { roles: payload?.roles });

  yield call(SignalingSocket.send, {
    event: 'bulkMuteRemoteAudio',
    ...(payload && { data: { roles: payload.roles } }),
  });
}
